"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _redux = require("redux");

var _immutable = require("immutable");

var _actions = require("settings-ui-sdk/SiteSettings/actions");

var _StagingActions = require("../actions/StagingActions");

var _UpdateSitemapsSettings = _interopRequireDefault(require("../stagedObjects/UpdateSitemapsSettings"));

var _constants = require("settings-ui-sdk/LanguageSettings/constants");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _handleActions;

var initialState = (0, _immutable.Map)();

var updateStateFromSiteSettings = function updateStateFromSiteSettings(data, state) {
  var bodyOverrideByDomain = data.bodyOverrideByDomain;

  if (bodyOverrideByDomain) {
    var _Map;

    var domains = Object.keys(bodyOverrideByDomain);
    var overrideMap = domains.reduce(function (map, domainName) {
      var _bodyOverrideByDomain = bodyOverrideByDomain[domainName],
          contentLanguage = _bodyOverrideByDomain[_constants.CONTENT_LANGUAGE],
          addDomainLangToSlug = _bodyOverrideByDomain[_constants.ADD_DOMAIN_LANG_TO_SLUG];
      return map.set(domainName, (0, _immutable.Map)({
        contentLanguage: contentLanguage,
        addDomainLangToSlug: addDomainLangToSlug
      }));
    }, state);
    var newState = overrideMap.set(_UrlPathParams.ALL_DOMAINS, (0, _immutable.Map)((_Map = {}, (0, _defineProperty2.default)(_Map, _constants.ENABLE_LANGUAGE_SPECIFIC_REDIRECTS, data[_constants.ENABLE_LANGUAGE_SPECIFIC_REDIRECTS]), (0, _defineProperty2.default)(_Map, _constants.CONTENT_LANGUAGE, data[_constants.CONTENT_LANGUAGE]), (0, _defineProperty2.default)(_Map, _constants.ADD_DOMAIN_LANG_TO_SLUG, data[_constants.ADD_DOMAIN_LANG_TO_SLUG]), _Map)));
    return newState;
  }

  var domain = Object.keys(data)[0];
  var contentLanguage = data[domain][_constants.CONTENT_LANGUAGE];
  var addDomainLangToSlug = data[domain][_constants.ADD_DOMAIN_LANG_TO_SLUG];
  var currentDomain = state.get(domain);
  var newDomain = currentDomain.merge({
    contentLanguage: contentLanguage,
    addDomainLangToSlug: addDomainLangToSlug
  });
  return state.set(domain, newDomain);
};

var updateLanguageSettings = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchSiteSettingsActionTypes.SUCCESS, function (state, _ref) {
  var data = _ref.payload.data;
  return updateStateFromSiteSettings(data, state);
}), (0, _defineProperty2.default)(_handleActions, _actions.SaveSiteSettingsChangesActionTypes.SUCCESS, function (state, _ref2) {
  var data = _ref2.payload.data;
  return updateStateFromSiteSettings(data, state);
}), (0, _defineProperty2.default)(_handleActions, _StagingActions.StagingActionTypes.STAGE_UPDATE_LANGUAGE_SETTING, function (state, action) {
  var _action$payload = action.payload,
      domain = _action$payload.domain,
      setting = _action$payload.setting,
      value = _action$payload.value;
  return state.setIn([domain, setting], value);
}), (0, _defineProperty2.default)(_handleActions, _StagingActions.StagingActionTypes.REPLACE_STAGED_LANGUAGE_SETTINGS, function (state, action) {
  var result = action.payload.reduce(function (map, setting, key) {
    if (key === _UrlPathParams.ALL_DOMAINS) {
      return map;
    }

    return map.setIn([key, 'contentLanguage'], setting.get('contentLanguage'));
  }, state);
  return result;
}), _handleActions), initialState);

var _default = (0, _redux.combineReducers)({
  updateLanguageSettings: updateLanguageSettings,
  updateSitemapsSettings: _UpdateSitemapsSettings.default.getReducer()
});

exports.default = _default;
module.exports = exports.default;